import { useEvent, useState } from 'hooks'
import { getFeedbackDetailSelectors } from 'selectors'

type State = {
	checkboxStateItems?: NodeListOf<HTMLInputElement>
	pinStateItems?: NodeListOf<HTMLElement>
}

export const FeedbackDetail = (() => {
	const { setState, state } = useState<State>()

	const checkToCorrespondingCheckbox = (id: string, checkboxItems: NodeListOf<HTMLInputElement>) => {
		const isGrayMode = isGrayCheckboxMode(checkboxItems)
		for (let i = 0; i < checkboxItems.length; i++) {
			if (!checkboxItems[i]) {
				continue
			}
			checkboxItems[i].checked = true

			if (isGrayMode) {
				if (checkboxItems[i].id === `status-${id}`) {
					checkboxItems[i].classList.remove('hide-pin-color')
				} else {
					checkboxItems[i].classList.add('hide-pin-color')
				}
			}

			if (checkboxItems[i].id === `status-${id}`) {
				const event = new Event('change')
				checkboxItems[i].dispatchEvent(event)
				break
			}
		}
	}

	const isGrayCheckboxMode = (checkboxItems: NodeListOf<HTMLInputElement>) => {
		for (let i = 0; i < checkboxItems.length; i++) {
			if (!checkboxItems[i]) {
				continue
			}
			if (checkboxItems[i].parentElement?.hasAttribute('data-gray-mode')) {
				return true
			}
		}
		return false
	}

	const uncheckAllCheckboxes = (checkboxItems: NodeListOf<HTMLInputElement>) => {
		for (let i = 0; i < checkboxItems.length; i++) {
			if (!checkboxItems[i]) {
				continue
			}
			checkboxItems[i].checked = false
		}
	}

	const handlePinClick = () => {
		const { pinStateItems } = state
		if (!pinStateItems) {
			return
		}

		for (let i = 0; i < pinStateItems.length; i++) {
			const pinStateItem = pinStateItems[i]
			if (!pinStateItem) {
				continue
			}
			const labelStateItem = pinStateItem.parentElement?.querySelector('label')
			if (!labelStateItem) {
				continue
			}
			const id = pinStateItem.id.split('-')[1]
			const click = useEvent(pinStateItem, 'click')
			const clickOnLabel = useEvent(labelStateItem, 'click')

			click.register(() => {
				const { checkboxStateItems } = state
				if (!checkboxStateItems) {
					return
				}

				uncheckAllCheckboxes(checkboxStateItems)
				checkToCorrespondingCheckbox(id, checkboxStateItems)
			})
			clickOnLabel.register(() => {
				const { checkboxStateItems } = state
				if (!checkboxStateItems) {
					return
				}

				uncheckAllCheckboxes(checkboxStateItems)
				checkToCorrespondingCheckbox(id, checkboxStateItems)
			})
		}
	}

	const handleInitSelectors = () => {
		setState({
			...getFeedbackDetailSelectors(),
		})
	}

	const init = () => {
		handleInitSelectors()
		handlePinClick()
	}

	return {
		init,
	}
})()
